__turbopack_context__.v({
  "callout": "bFuxEG_callout",
  "calloutLabel": "bFuxEG_calloutLabel",
  "callouts": "bFuxEG_callouts",
  "calloutsInner": "bFuxEG_calloutsInner",
  "canvas": "bFuxEG_canvas",
  "cymatic": "bFuxEG_cymatic",
  "fail": "bFuxEG_fail",
  "hoverBadge": "bFuxEG_hoverBadge",
  "pass": "bFuxEG_pass",
  "visible": "bFuxEG_visible",
});
